// extracted by mini-css-extract-plugin
module.exports = {"container":"PatientStyles_container__X8_2N"};